<template>
  <embed
    src="Kyle_Damschen_Resume.pdf"
    type="application/pdf"
    width="100%"
    height="100%"
  />
</template>
